declare namespace $ {

	export class $shm_agent_app_sessions extends $shm_hitalama_dragtree {
		drag_hold_delay( ): number
		drag_touch_action( ): string
		can_have_children( id: any): boolean
		can_be_child( id: any): boolean
		locked( ): boolean
		pinned( id: any): boolean
	}
	
}

//# sourceMappingURL=sessions.view.tree.d.ts.map